const regex = /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/;

export const getSpotifyIdFromURL = (url) => {
  // https://open.spotify.com/track/5xmuhISa7P9u7XoXP1gE1x?si=6ac9d9c1bae5417f
  let m;
  m = regex.exec(url);
  const domain = m[2];

  if (!domain.includes("spotify.com")) {
    return null;
  }

  const route = m[5];

  const trackId = route.includes("/track/") ? route.replace("/track/", "") : null;
  if (trackId)
    return {
      type: "track",
      id: trackId,
    };
  const albumId = route.includes("/album/") ? route.replace("/album/", "") : null;
  if (albumId)
    return {
      type: "album",
      id: albumId,
    };
  const playlistId = route.includes("/playlist/") ? route.replace("/playlist/", "") : null;
  if (playlistId)
    return {
      type: "playlist",
      id: playlistId,
    };

  return null;
};

export const getSpotifyRouteFromURL = (url) => {
  // https://open.spotify.com/track/5xmuhISa7P9u7XoXP1gE1x?si=6ac9d9c1bae5417f
  let m;

  m = regex.exec(url);
  return m[5];
};
